
export class KYMW0906InputModel {

  // モード：追加
  public static MODO_ADD = 1;

  // モード：詳細
  public static MODO_DETAIL = 2;

  // モード：閲覧
  public static MODO_READ_ONLY = 3;

  // モード：選択値
  public mode: number = null;

  // 登録済みの配達企画回・アイテムコードの組み合わせリスト
  public registeredDeliveryCatalogAndItemCodeList = [];

  // 束ね企画回の終了受注コード
  public bundleEndDeliveryOrder = '';

  // 配達企画回
  public deliveryCatalog = '';

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードのリスト
  public itemCodeList = [];

  // アイテムコードに紐付く会員生協リスト
  public enableCoopByItemCodeList = [];

  // 注文コード割当
  public preOrderNumQuotaCode = '';

  // 注文コード割当のリスト
  public preOrderOrderNumQuotaCodeList = [];

  // 注文コード
  public orderNum = '';

  // 配達企画曜日:月
  public delivMonday = false;

  // 配達企画曜日:火
  public delivTuesday = false;

  // 配達企画曜日:水
  public delivWednesday = false;

  // 配達企画曜日:木
  public delivThursday = false;

  // 配達企画曜日:金
  public delivFriday = false;

  // 専用商品名
  public preOrderGoodsName = '';

  // 専用商品名(カナ)
  public preOrderGoodsNameKana = '';

  // 専用規格名
  public preOrderStandardName = '';

  // 専用規格名(カナ)
  public preOrderStandardNameKana = '';

  // セット企画
  public setPreOrderType = false;

  // 供給価格（通常）
  public supplyPriceStandard = '';

  // 値引区分
  public discountType = '0';

  // 値引単価
  public discountUnitPrice = '';

  // 値引率
  public discountRate = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // ポイント数
  public preOrderPoints = '';

  // 価格パターン
  public pricePattern = '0';

  // 価格パターンに対応する供給単価リスト
  public preOrderSupplyPriceList = [];

  // 商品計画数予測リスト
  public goodsPlanNumList = [];

  // アイテムコードに紐づく会員生協
  public itemRelatedCoop = [];

  // 会員タブのアイテムコードに紐づく会員生協
  public itemRelatedCoop_CoopTab = [];

  // 配達企画回、アイテムコードに紐づく会員生協
  public catalogAndItemRelatedCoop = [];

  // 会員タブでアイテムコードが選択されている生協リスト
  public enabledCoopList: any[] = [];
}
